import { render } from "./searchForm.vue?vue&type=template&id=62b6c4e4&scoped=true"
import script from "./searchForm.vue?vue&type=script&lang=js"
export * from "./searchForm.vue?vue&type=script&lang=js"

import "./searchForm.vue?vue&type=style&index=0&id=62b6c4e4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b6c4e4"]])

export default __exports__